import { DecorationModel } from "../_model/DecorationModel";
import { ControllerTowerCO2 } from "./controllerTowerCO2";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { COLORS } from "../../utils/colors";
import Resize from "../_decorationTools/risezeClass";
import * as d3 from "d3";
import { SingletonInter } from "../_service/singletonInter";


export class DecorationTowerCO2 extends DecorationModel {
  constructor() {
    super("DecorationTowerCO2");
    this.node = null;
    this.ctr = new ControllerTowerCO2();
    let resize = new Resize();

    this.init = async function(newNode) {
      let svg = SingletonFlowchart.svg;
      this.node = newNode;

      await svg
        .data([newNode])
        .append("g")
        .attr("id", `${newNode.idName}`)
        .append("rect")
        .classed("TowerCO2", true)
        .attr("x", (d) => d.x)
        .attr("y", (d) => d.y)
        .style("cursor", "grab")
        .style("fill", COLORS.ClearBlue);

      let g = d3.select(`#${newNode.idName}`);

      g.append("image")
        .attr("width", newNode.width)
        .attr("height", newNode.height)
        .attr("x", newNode.xImg())
        .attr("y", newNode.yImg())
        .attr("xlink:href", newNode.srcImg)
        .style("cursor", "grab")
        .on("mouseover", resize.mouseOver)
        .on("mouseout", resize.mouseOut)
        .call(this.setDrag())
        .append("title")
        .text(SingletonInter.$t('cO2Tower'))
        .node();

      resize.apply(g, newNode);
      return svg;
    };

    this.setDrag = function() {
      if (this.node.readOnly) 
      return d3.drag();

      let that = this;
      let drag = d3
        .drag()
        .on("start", that.dragstarted)
        .on("drag", (event, d) => that.dragged(event, d))
        .on("end", that.dragended);
      return drag;
    };

    this.dragstarted = function(event, d) {
      SingletonFlowchart.selectNode(`${d.idName}`);

      d3.select(this)
        .style("stroke", "black")
        .style("cursor", "grabbing");
    };

    this.dragged = async function(event, d) {
      d.x = event.x;
      d.y = event.y;

      SingletonFlowchart.clicked = false;

      this.move();
    };

    this.move = async function() {
      await d3
        .select(`#${this.node.idName} > image`)
        .raise()
        .attr("x", this.node.xImg())
        .attr("y", this.node.yImg());

      await d3
        .selectAll(`#${this.node.idName} > circle`)
        .raise()
        .attr("cx", this.node.x + this.node.width)
        .attr("cy", this.node.y + this.node.height);

      resize.move(this.node);
    };

    this.dragended = function() {
      d3.select(this)
        .style("stroke", "none")
        .style("cursor", "grab");

      SingletonFlowchart.SaveStatus();
    };
  }
}
